@if (formModel) {
  <form #formComponent="ngForm" (ngSubmit)="submit(form.value)" [formGroup]="form" class="form-horizontal text-start">
    @for (el of formModel.inputs; track $index) {
      @let inputElem = castFormInput(el);
      <div [attr.data-test]="inputElem.name + '-group'" class="mb-3">
        @if (!inputElem.isHidden) {
          @if (inputElem.inputInfoHTML) {
            <div [innerHTML]="inputElem.inputInfoHTML | safeCMSContent: 'html'"></div>
          }
          @if (inputElem.hasOwnProperty('initialValue')) {
            @if (!inputElem.componentType || inputElem.componentType === 'input') {
              <mwe-form-input
                (inputBlurred)="inputBlurred.emit()"
                [inputElem]="inputElem"
                [isInline]="isInline"
                [isLoading]="isLoading"
                [parentForm]="form"
              />
            }
            @if (inputElem.componentType === 'checkbox') {
              <mwe-checkbox-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'radio') {
              <mwe-radio-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'typeahead') {
              <mwe-typeahead-input [formControlName]="inputElem.name" [formInputOptions]="inputElem" [isLoading]="isLoading" />
            }
            @if (inputElem.componentType === 'emailToConfirm') {
              <mwe-email-confirmation
                (setControlVisibility)="setControlVisibility($event.controlName, $event.isVisible)"
                [allFormInputs]="castFormInputArray(formModel.inputs)"
                [isLoading]="isLoading"
                [parentForm]="form"
              />
            }
            @if (inputElem.componentType === 'date') {
              <mwe-date-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'birthdate') {
              <mwe-birthdate-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'datepicker') {
              <mwe-datepicker-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'textarea') {
              <mwe-form-textarea [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }

            @if (inputElem.componentType === 'select') {
              <mwe-form-select
                (selectChanged)="onSelectChange($event.option, $event.name)"
                [inputElem]="inputElem"
                [isLoading]="isLoading"
                [parentForm]="form"
                [selectedValue]="selectedValue"
              />
            }
            @if (inputElem.componentType === 'selectable-card-check') {
              <mwe-selectable-card-checkbox-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (inputElem.componentType === 'selectable-card-radio') {
              <mwe-selectable-card-radio-input [inputElem]="inputElem" [isLoading]="isLoading" [parentForm]="form" />
            }
            @if (!isInputEmailConfirmation(inputElem.componentType)) {
              <mwe-form-input-error [errorId]="inputElem.uuid" [inputElem]="inputElem" [parentForm]="form" />
            }
          }
          @if (inputElem.hasOwnProperty('inputs')) {
            @if (inputElem.componentType === 'comboboxSelect') {
              <mwe-combobox-select [inputElem]="castFormGroup(inputElem)" [isLoading]="isLoading" [parentForm]="form" />
              <mwe-form-input-error [inputElem]="inputElem" [parentForm]="form" />
            } @else {
              <div [class]="castFormGroup(inputElem).rowClass" [ngClass]="{ 'g-3': !castFormGroup(inputElem).rowClass }" class="row">
                @for (elInner of castFormGroup(inputElem).inputs; track $index) {
                  @let inputElemInner = castFormInput(elInner);
                  <div [class]="inputElemInner.inputClasses">
                    @if (!inputElemInner.isHidden) {
                      @if (!inputElemInner.componentType || inputElemInner.componentType === 'input') {
                        <mwe-form-input
                          (inputBlurred)="inputBlurred.emit()"
                          [inputElem]="inputElemInner"
                          [isInline]="isInline"
                          [isLoading]="isLoading"
                          [parentForm]="form"
                        />
                      }
                      @if (inputElemInner.componentType === 'checkbox') {
                        <mwe-checkbox-input [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }
                      @if (inputElemInner.componentType === 'radio') {
                        <mwe-radio-input [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }

                      @if (inputElemInner.componentType === 'selectable-card-check') {
                        <mwe-selectable-card-checkbox-input [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }
                      @if (inputElemInner.componentType === 'selectable-card-radio') {
                        <mwe-selectable-card-radio-input [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }
                      @if (inputElemInner.componentType === 'date') {
                        <mwe-date-input [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }

                      @if (inputElemInner.componentType === 'typeahead') {
                        <mwe-typeahead-input
                          [formControlName]="inputElemInner.name"
                          [formInputOptions]="inputElemInner"
                          [isLoading]="isLoading"
                        />
                      }
                      @if (inputElemInner.componentType === 'select') {
                        <mwe-form-select
                          (selectChanged)="onSelectChange($event.option, $event.name)"
                          [inputElem]="inputElemInner"
                          [isLoading]="isLoading"
                          [parentForm]="form"
                          [selectedValue]="selectedValue"
                        />
                      }
                      @if (inputElemInner.componentType === 'textarea') {
                        <mwe-form-textarea [inputElem]="inputElemInner" [isLoading]="isLoading" [parentForm]="form" />
                      }
                      <mwe-form-input-error [inputElem]="inputElemInner" [parentForm]="form" />
                    }
                  </div>
                }
              </div>
            }
          }
        }
      </div>
    }
    @if (formModel.isResetButtonVisible || formModel.isSubmitButtonVisible) {
      <div class="mt-5 submit text-end form-buttons" id="form-buttons">
        @if (formModel.isResetButtonVisible) {
          <mwe-button (clicked)="reset()" [disabled]="isLoading || form.pristine" [labelKey]="formModel.resetLabelKey" buttonId="reset" />
        }
        @if (formModel.isSubmitButtonVisible) {
          <mwe-button
            [disabled]="isLoading || form.invalid"
            [labelKey]="formModel.submitLabelKey"
            [showHoverEffect]="true"
            [showSpinner]="isLoading"
            buttonId="mwe-form-submit"
            buttonType="submit"
          />
        }
      </div>
    }
  </form>
}
